import React, { useMemo } from 'react';
import Text from 'design-system/Text';
import Links from 'utils/links';
import { cleanLinkText, splitTextByLinks } from 'utils/textLinks';
const TextWithLinks = ({ children, ...props }) => {
    const segments = useMemo(() => splitTextByLinks(children), [children]);
    // Primary takes precedence over any other color prop passed by the caller,
    // as Text resolves color props in a fixed order with Primary first.
    const linkProps = { ...props, Primary: true };
    return (<Text {...props}>
      {segments.map((segment, index) => {
            const { text, url } = segment;
            if (!url) {
                return text;
            }
            return (<Text {...linkProps} key={`${url}-${index}`} accessibilityRole="link" suppressHighlighting onPress={() => Links.openLink(url)}>
            {cleanLinkText(text)}
          </Text>);
        })}
    </Text>);
};
export default TextWithLinks;
